<template>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <!-- Cards de Métricas -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <!-- Total RFIs -->
      <div class="bg-white rounded-lg shadow border-t-4 border-brand-600 p-6">
        <h3 class="text-lg font-medium text-gray-500">Total RFIs</h3>
        <p class="mt-2 text-3xl font-semibold text-gray-900">
          {{ metrics.totalRfis }}
        </p>
      </div>

      <!-- RFIs Abiertos -->
      <div class="bg-white rounded-lg shadow border-t-4 border-accent-500 p-6">
        <h3 class="text-lg font-medium text-gray-500">Open RFIs</h3>
        <p class="mt-2 text-3xl font-semibold text-accent-600">
          {{ metrics.openRfis }}
        </p>
        <p class="mt-1 text-sm text-gray-500">
          In Progress: {{ metrics.statusCounts["In Progress"] || 0 }}, Submitted
          and waiting: {{ metrics.statusCounts["Submitted and waiting"] || 0 }},
          Re-assigned: {{ metrics.statusCounts["Re-assigned"] || 0 }}
        </p>
      </div>

      <!-- RFIs Cerrados -->
      <div class="bg-white rounded-lg shadow border-t-4 border-brand-400 p-6">
        <h3 class="text-lg font-medium text-gray-500">Completed RFIs</h3>
        <p class="mt-2 text-3xl font-semibold text-brand-700">
          {{ metrics.completedRfis }}
        </p>
        <p class="mt-1 text-sm text-gray-500">Status: Completed</p>
      </div>
    </div>

    <!-- RFIs por Requester -->
    <div class="bg-white rounded-lg shadow p-6 mb-8">
      <h3 class="text-lg font-medium text-gray-500 mb-4">RFIs by Requester</h3>
      <div class="space-y-4">
        <div
          v-for="(requester, index) in metrics.requestersMetrics"
          :key="index"
        >
          <div class="flex justify-between mb-1">
            <span class="text-sm font-medium text-gray-700">{{
              requester.name
            }}</span>
            <span class="text-sm font-medium text-gray-700"
              >{{ requester.total }} RFIs</span
            >
          </div>
          <div class="w-full bg-brand-50 rounded-full h-2.5">
            <div
              class="bg-brand-600 h-2.5 rounded-full"
              :style="`width: ${(requester.total / metrics.totalRfis) * 100}%`"
            ></div>
          </div>
          <div class="flex justify-between mt-1 text-xs text-gray-500">
            <span>Open: {{ requester.open }}</span>
            <span>Completed: {{ requester.completed }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- RFIs Pendientes con Directed To -->
    <div class="bg-white rounded-lg shadow p-6">
      <h3 class="text-lg font-medium text-gray-500 mb-4">
        Pending RFIs - Directed To
      </h3>
      <div class="space-y-4">
        <div
          v-for="(directed, email) in metrics.directedToMetrics"
          :key="email"
        >
          <div class="flex justify-between mb-1">
            <span class="text-sm font-medium text-gray-700">{{ email }}</span>
            <span class="text-sm font-medium text-gray-700"
              >{{ directed.count }} RFIs</span
            >
          </div>
          <div class="w-full bg-brand-50 rounded-full h-2.5">
            <div
              class="bg-accent-500 h-2.5 rounded-full"
              :style="`width: ${
                metrics.pendingDirectedTotal > 0
                  ? (directed.count / metrics.pendingDirectedTotal) * 100
                  : 0
              }%`"
            ></div>
          </div>
          <div class="mt-1 text-xs text-gray-500">
            <span>{{ directed.rfis.join(", ") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  props: {
    metrics: {
      type: Object,
      required: true,
      default: () => {},
    },

  },

  setup() {
 
  },
};
</script>